import { render, staticRenderFns } from "./BatchHistory.vue?vue&type=template&id=7b044147&scoped=true&"
import script from "./BatchHistory.vue?vue&type=script&lang=js&"
export * from "./BatchHistory.vue?vue&type=script&lang=js&"
import style0 from "./BatchHistory.vue?vue&type=style&index=0&id=7b044147&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b044147",
  null
  
)

export default component.exports